<template>
  <div ref="img-border" class="top-img-class" :style="{ height: borderHeight }">
    <img
      :style="{
        width: imgWidth,
        height: imgHeight,
        'margin-top': marginTop,
        'margin-left': marginLeft,
      }"
      :src="theSrc"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: "jlkj-center-img",
  props: {
    scale: {
      type: Array,
    },
    src: {
      type: String,
    },
  },
  data() {
    return {
      widthOrHeight: true,
      nowScale: this.scale,
      imgHeight: "0",
      imgWidth: "0",
      borderHeight:
        "calc( 100vw / " + this.scale[0] + " * " + this.scale[1] + " )",
      marginTop: "0",
      marginLeft: "0",
      theSrc: "",
    };
  },
  computed: {
    divWidth: function () {
      this.$nextTick(() => {
        return this.$refs["img-border"].offsetWidth;
      });
    },
  },
  watch: {
    divWidth: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.imgLoad();
      }
    },
  },
  mounted() {
    this.imgLoad();
  },
  methods: {
    imgLoad() {
      let imgObj = new Image();
      imgObj.src = this.src;
      imgObj.onload = () => {
        console.log(
          "ni",
          imgObj.width,
          imgObj.height,
          this.nowScale,
          this.$refs["img-border"].offsetWidth
        );
        let temp =
          (this.$refs["img-border"].offsetWidth / this.nowScale[0]) *
          this.nowScale[1];
        this.borderHeight = temp + "px";
        if (
          imgObj.width / this.nowScale[0] >
          imgObj.height / this.nowScale[1]
        ) {
          //img宽的比例更长,显示区域裁剪左右两边宽
          this.imgHeight = temp + "px";
          this.imgWidth = (temp / imgObj.height) * imgObj.width + "px";
          this.marginLeft =
            "-" +
            ((temp / imgObj.height) * imgObj.width -
              this.$refs["img-border"].offsetWidth) /
              2 +
            "px";
          this.marginTop = "0";
        } else {
          //img高的比例更长，显示区域裁剪上下两边高
          this.imgWidth = this.$refs["img-border"].offsetWidth + "px";
          this.imgHeight =
            (this.$refs["img-border"].offsetWidth / imgObj.width) *
              imgObj.height +
            "px";
          this.marginTop =
            "-" +
            ((this.$refs["img-border"].offsetWidth / imgObj.width) *
              imgObj.height -
              temp) /
              2 +
            "px";
          this.marginLeft = "0";
        }
        this.theSrc = this.src;
        console.log("margin", this.marginTop, this.marginLeft);
      };
    },
  },
};
</script>
<style scoped>
@import "../../../lib/flex-list.css";
.top-img-class {
  width: 100vw;
  overflow: hidden;
}
/* .img-width-100{
        width:100%;
    }
    .img-height-100{
        height:100%;
    } */
</style>